import React from "react";
import { Chip } from "@mui/material";

export const getDashboardKpiStatus = (color) => {
  const normalized = String(color || "").toUpperCase();

  if (["#3CD856", "#12B76A", "#16A36A"].includes(normalized)) {
    return { label: "On track", color: "#16A36A", soft: "#E9FBF3" };
  }

  if (["#FA5A7D", "#F64E60", "#F04438", "#E5484D"].includes(normalized)) {
    return { label: "Attention", color: "#E5484D", soft: "#FFF0F1" };
  }

  return { label: "Baseline", color: "#E59A16", soft: "#FFF8E8" };
};

const DashboardKpiStatus = ({ color }) => {
  const status = getDashboardKpiStatus(color);

  return (
    <Chip
      label={status.label}
      size="small"
      sx={{
        position: "absolute",
        top: 10,
        right: 10,
        height: 18,
        borderRadius: "999px",
        bgcolor: status.soft,
        color: status.color,
        border: `1px solid ${status.color}33`,
        fontSize: 8.5,
        fontWeight: 650,
        textTransform: "uppercase",
        "& .MuiChip-label": { px: 0.75 },
      }}
    />
  );
};

export default DashboardKpiStatus;
